<template>
  <div class="container">
      <div v-if="isOnline && settings.apiEndpoint !== null">
        <div v-for="survey in surveys" :key="survey.id" class="list">
            <a @click.prevent="importSurvey(survey)" class="import-link">#{{ survey.id }} - Click to import {{ survey.name }}</a>
        </div>
      </div>
      <div v-else>{{ message }}</div>
  </div>
</template>

<script>
import axios from 'axios';
import {
    surveys as surveysDb,
    settings as settingsDb
} from '@/database';

export default {
    name: 'Import',

    data() {
        return {
            surveys: [],
            settings: {},
            message: '',
        }
    },

    methods: {
        importSurvey({ id, name}) {
            if ( confirm(`You really want to import ${name} ?`) ){
                axios.get(`${this.settings.apiEndpoint}index.php?survey=${id}`).then(response => {
                    this.survey = response.data;
                    surveysDb.setItem(id, response.data).then(() => {
                        this.$store.dispatch('buildSurveys')
                        this.$router.push({name:'dashboard'})
                    })
                })
                .catch(error => {
                    console.log(error)
                })
            }
        }
    },

    computed: {
        isOnline() {
            return this.$parent.online;
        }
    },

    mounted() {
        (async() => {
            this.settings.apiEndpoint = await settingsDb.getItem('api-endpoint');
            this.settings.username = await settingsDb.getItem('username');
            this.settings.password = await settingsDb.getItem('password');

            if ( this.settings.apiEndpoint === null ) {
                this.$router.push({ name: 'settings' });
                return;
            }

            if ( ! this.isOnline ) {
                this.message = 'It seems like you are not connected.';
                return;
            }


            await axios.get(`${this.settings.apiEndpoint}index.php`).then(response => {
                this.surveys = response.data;
            })
            .catch(error => {
                console.log(error)
            })
        })();
    }
}
</script>

<style style="scss" scoped>
.list {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 500px;
}
.import-link {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: .5rem 0 1rem 0;
    padding: .5rem;
    width: 100%;
    min-height: 48px;
    color: black;
    font-size: 1.6rem;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    border: 1px solid #666;
    background-color: var(--primary);
    border-radius: 3px;
    cursor: pointer;
}
</style>